import { combineReducers } from 'redux';
import foos from './foos/foosReducers';
import users from './users/usersReducers';
import terminus from './terminus/terminusReducers';
import terminusDrilldown from './terminusDrilldown/terminusDrilldownReducers';
import keyManager from './keyManager/keyManagerReducers';
import mediaBrowser from './mediaBrowser/mediaBrowserReducers';
import spottingGroup from './spottingGroup/spottingGroupReducers';
import job from './jobs/jobsReducers';
import spottingGroupDrilldown from './spottingGroupDrilldown/spottingGroupDrilldownReducers';
import modelCustomVocabulary from './models/CustomVocabulary/customVocabularyReducers';
import modelSpottingGroup from './models/SpottingGroup/spottingGroupReducers';
import modelPages from './models/pages/pagesReducers';

export default combineReducers({
  foos,
  users,
  terminus,
  keyManager,
  mediaBrowser,
  terminusDrilldown,
  job,
  spottingGroup,
  spottingGroupDrilldown,
  modelCustomVocabulary,
  modelSpottingGroup,
  modelPages,
});
